import React, { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound: FC = () => {
  const { i18n } = useTranslation();
  const isFr = i18n.language.startsWith('fr');

  useEffect(() => {
    document.title = isFr ? 'Page introuvable — AidFone' : 'Page not found — AidFone';
  }, [isFr]);

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center px-4 font-body">
      <div className="w-full max-w-md">
        <Link to={isFr ? '/fr' : '/'} className="flex items-center justify-center mb-8">
          <img
            src="/images/landing/aidfone-logo-horizontal.png"
            alt="AidFone"
            className="h-10"
          />
        </Link>
        <div className="bg-white rounded-2xl border border-brand-border p-8 shadow-sm text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-slate-50 flex items-center justify-center">
            <span className="material-symbols-outlined text-slate-400 text-3xl">
              search_off
            </span>
          </div>
          <h1 className="text-xl font-display font-bold text-brand-text mb-2">
            {isFr ? 'Page introuvable' : 'Page not found'}
          </h1>
          <p className="text-sm text-brand-text-muted mb-6">
            {isFr
              ? "La page que vous cherchez n'existe pas ou a été déplacée."
              : "The page you're looking for doesn't exist or has moved."}
          </p>
          <Link
            to={isFr ? '/fr' : '/'}
            className="inline-block text-sm text-brand-primary font-medium hover:underline"
          >
            {isFr ? "← Retour à l'accueil" : '← Back to home'}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
